import axios from 'axios'
import { API_BASE } from '../api'
import { apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'
import qOptions from '@/services/surveyQuestions/options'

const SURVEY_RESPONSE_ENDPOINT = `${API_BASE}survey-responses/`

export default class SurveyResponseAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new SurveyResponseAPI(cls)
  }

  create(surveyResponse) {
    const data = this.cls.toAPI(surveyResponse)
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(SURVEY_RESPONSE_ENDPOINT, data, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Create Survey Response API', rethrowErrors: true }))
  }

  retrieve(surveyResponseId) {
    const url = `${SURVEY_RESPONSE_ENDPOINT}${surveyResponseId}/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios
      .get(url, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Survey Response API Error', rethrowError: true }))
    return promise
  }

  update(surveyResponse) {
    const url = `${SURVEY_RESPONSE_ENDPOINT}${surveyResponse.id}/`
    const data = {
      questions: surveyResponse.questions.map(this.serializeQuestionAnswerForPatching),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios
      .patch(url, data, options)
      .catch(apiErrorHandler({ apiName: 'Survey Response API Error', rethrowError: true }))
    return promise
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      // Filtering
      employee: ApiFilter.create({ key: 'employee' }),
      surveyName: ApiFilter.create({ key: 'survey_name' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = axios
      .get(`${SURVEY_RESPONSE_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List SurveyResponse API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }

  // TODO (Bruno 4-2-20): Build SurveyAnswer.toAPI -- this class is at
  //                     lower half of @/services/surveyQuestions/models.
  serializeQuestionAnswerForPatching(q) {
    switch (q.qType) {
      case qOptions.MULTIPLE_CHOICE: {
        return {
          id: q.id,
          answer: { option: q.answer.option },
        }
      }
      case qOptions.FREE_TEXT: {
        return {
          id: q.id,
          answer: { text: q.answer.text },
        }
      }
      case qOptions.NUMBER: {
        return {
          id: q.id,
          answer: { text: q.answer.text },
        }
      }
      case qOptions.MULTI_SELECT: {
        return {
          id: q.id,
          answer: { options: q.answer.options },
        }
      }
      default:
        throw new Error('Invalid question type', 'SurveyResposeAPI.update')
    }
  }
}
